import { t } from 'ttag';
import {
  FlipBackDefinition,
  FlipCardDefinition,
  FlipFrontDefinition,
  FLIP_BACK,
  FLIP_CARD,
  FLIP_FRONT,
  LayoutGridDefinition,
  LayoutListDefinition,
  LAYOUT_GRID,
  LAYOUT_LIST,
  TEXT,
  TWEET,
  TWEET_LOCK
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const SocialMedia12: Translator = sequence => {
  const cardsList = {
    type: LAYOUT_GRID,
    id: `${sequence.id}-card`,
    items: [],
    values: {}
  } as LayoutGridDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        cardsList.items.push({
          id: item.id,
          type: FLIP_CARD,
          values: {
            width: '98%',
            padding: '0'
          },
          items: [
            {
              id: `${item.id}.front`,
              type: FLIP_FRONT,
              items: [
                {
                  id: `${item.id}.front-list`,
                  type: LAYOUT_LIST,
                  values: {},
                  items: [
                    {
                      type: TWEET,
                      id: `tweet-${item.id}`,
                      values: {
                        pic:
                          sequence.personalization && sequence.logoUrl
                            ? sequence.logoUrl
                            : item?.pictures && item?.pictures.length >= 0
                            ? item?.pictures[0]?.mediaUrl
                            : false,
                        name: item.title,
                        alias: item.subtitle,
                        width: '100%',
                        height: '100%'
                      },
                      items: [
                        {
                          type: TEXT,
                          id: 'tweet_body',
                          items: [],
                          values: {
                            value: item.body
                          }
                        }
                      ]
                    }
                  ]
                } as LayoutListDefinition
              ]
            } as FlipFrontDefinition,
            {
              id: `${item.id}.back`,
              type: FLIP_BACK,
              items: [
                {
                  id: `${item.id}.back-list`,
                  type: LAYOUT_LIST,
                  values: {
                    padded: false
                  },
                  items: [
                    {
                      type: TWEET_LOCK,
                      id: `tweet-${item.id}`,
                      values: {
                        text:
                          item.variant === 'flip' && item.disappear
                            ? item.disappear
                            : null,
                        width: '100%',
                        height: '100%'
                      },
                      items: [
                        {
                          type: TEXT,
                          id: 'tweet_body',
                          items: [],
                          values: {
                            value: t`Click To View Post`
                          }
                        }
                      ]
                    }
                  ]
                } as LayoutListDefinition
              ]
            } as FlipBackDefinition
          ]
        } as FlipCardDefinition);
    }
    return null;
  });

  root.items.push(cardsList);
  return root;
};
